import * as Types from "../constants/TypeActions";

let Initstate = {
  user:{},
  dataHistory:null,
  infoBet:null

};

const reducer = (state = Initstate, action) =>
{
    switch (action.type) {
        case Types.SET_USER:
            state = {
                ...state,
                user: action.result,
            };
            return { ...state };
            case Types.SET_HISTORY:
                state = {
                    ...state,
                    dataHistory: action.result,
                };
                return { ...state };
            case Types.SET_INFOBET:
                state = {
                    ...state,
                    infoBet: action.result,
                };
                return { ...state };
        default:
            return { ...state };


    }
};
export default reducer;
